import { Observable } from "rxjs";
import { finalize, first } from "rxjs/operators";

export class TableHelper {
    originalData: any[] = [];
    data: any[] = [];
    dataIntervention: any[] = [];
    dataScheduled: any[] = [];
    dataTasks: any[] = [];
    dataTasksOther: any[] = [];
    tableLoading = false;
    tableScheduled = false;
    tableTasks = false;
    tablePedidosLoading = false;

    isSearchable = true;
    searchTerm = '';

    pagination = true;
    serverSidePagination = false;

    startIndex = 0;
    endIndex = 0;
    totalRecords = 0;
    totalScheduledRecords = 0;
    totalTasksRecords = 0;
    totalTasksOtherRecords = 0;

    page = 1;
    pageSize = 10;
    pageSizeOptions: number[] = [10, 25, 50, 100];

    constructor() {}

    startTable() {
        this.searchData();
    }

    loadData(data: any[], metadata?: any) {
        this.data = [];
        this.tableLoading = true;

        if (this.serverSidePagination) {
            this.data = data;
            this.page = metadata.page + 1;
            // this.pageSize = metadata.perPage;
            this.updateCounts(metadata.count);
        } else {
            // this.data = data;
            this.totalRecords = data.length;
            this.originalData = data;
            if (!this.page || this.page < 1) {
                this.page = 1;
            }
            this.pageSize = 10;
            this.drawPage();
            this.updateCounts(data.length);
        }
        this.tableLoading = false;
    }

    loadDataObservable(obs: Observable<any>) {

        this.data = [];
        this.tableLoading = true;
        obs.pipe(first(), finalize(() => this.tableLoading = false)).subscribe(result => {
            if (this.serverSidePagination) {
                this.data = result.data;
                if ((result.metadata.page + 1) !== this.page) this.page = result.metadata.page + 1;
                //this.pageSize = result.metadata.perPage;
                this.updateCounts(result.metadata.count);
            } else {
                // this.data = result.data;
                this.totalRecords = result.data.length;
                this.originalData = result.data;
                if (!this.page || this.page < 1) {
                    this.page = 1;
                }
                this.pageSize = 10;
                this.drawPage();
                this.updateCounts(result.data.length);
            }
        });
    }

    drawPage() {
        this.data = this.originalData.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
        this.updateCounts(1)
    }
    drawPageShceduled() {
        this.dataScheduled = this.dataScheduled.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
        this.updateCounts(1)
    }
    drawPageTasks() {
        this.dataTasks = this.dataTasks.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
        this.updateCounts(1)
    }

    searchData() {
        this.loadData(this.data);
    }

    updateCounts(count: number) {
        this.totalRecords = count;
        this.startIndex = this.totalRecords === 0 ? 0 : (this.page - 1) * this.pageSize + 1;
        const ps = this.page * this.pageSize;
        this.endIndex = ps > this.totalRecords ? this.totalRecords : ps;
    }

    updateCountsPedidos(count: number) {
        this.totalRecords = count;
        this.startIndex = this.pageSize * (this.page - 1) === 0 ? 1 : this.pageSize * (this.page - 1);
        const ps = this.pageSize * (this.page);
        this.endIndex = ps > this.totalRecords ? this.totalRecords : ps;
    }
    updateCountsScheduled(count: number) {
        this.totalScheduledRecords = count;
        this.startIndex = this.pageSize * (this.page - 1) === 0 ? 1 : this.pageSize * (this.page - 1);
        const ps = this.pageSize * (this.page);
        this.endIndex = ps > this.totalScheduledRecords ? this.totalScheduledRecords : ps;
    }
    updateCountsTasks(count: number) {
        this.totalTasksRecords = count;
        this.startIndex = this.pageSize * (this.page - 1) === 0 ? 1 : this.pageSize * (this.page - 1);
        const ps = this.pageSize * (this.page);
        this.endIndex = ps > this.totalTasksRecords ? this.totalTasksRecords : ps;
    }
    paginate() {
        if (this.totalRecords > 0) {
            if (this.serverSidePagination) {
                this.searchData();
            } else {
                this.drawPage();
            }
        }
    }

    loadDataTickets(obs: any) {
        this.data = [];
        this.tableLoading = true;
        this.totalRecords = obs.length;
        this.originalData = obs;
        if (!this.page || this.page < 1) {
            this.page = 1;
        }
        this.pageSize = 20;
        this.drawPage();
        this.updateCounts(obs.length);
        this.tableLoading = false;

    }
    loadDataTicketsDash(obs: any) {
        this.data = [];
        this.tableLoading = true;
        this.totalRecords = obs.length;
        this.originalData = obs;
        if (!this.page || this.page < 1) {
            this.page = 1;
        }
        this.pageSize = obs.length;
        this.drawPage();
        this.updateCounts(obs.length);
        this.tableLoading = false;
    }
    loadDataScheduled(obs: any) {
        this.dataScheduled = [];
        this.tableScheduled = true;
        this.totalScheduledRecords = obs.length;
        this.dataScheduled = obs;
        if (!this.page || this.page < 1) {
            this.page = 1;
        }
        this.pageSize = 20;
        this.drawPageShceduled();
        this.updateCountsScheduled(obs.length);
        this.tableScheduled = false;
    }

    loadDataTasksDashboard(obs: any) {
        this.dataTasks = [];
        this.dataTasksOther = [];
        this.tableTasks = true;
        obs.forEach((obj: any, index: any) => {
            if (obj.techniciantask == "0" || obj.techniciantask == "NULL") {
                this.dataTasksOther.push(obj)
            } else {
                this.dataTasks.push(obj)
            }
        });
        this.totalTasksRecords = this.dataTasks.length;
        this.dataTasks.forEach((obj, index) => {
            if (obj.status === "Completed") {
                this.dataTasks.splice(index, 1);
            }
        });

        ////other
        this.totalTasksOtherRecords = this.dataTasksOther.length;
        this.dataTasksOther.forEach((obj, index) => {
            if (obj.status === "Completed") {
                this.dataTasksOther.splice(index, 1);
            }
        });
        if (!this.page || this.page < 1) {
            this.page = 1;
        }
        this.pageSize = 1000;

        this.tableTasks = false;
    }

    loadDataTasks(obs: any) {
        this.dataTasks = [];
        this.tableTasks = true;
        this.totalRecords = obs.length;
        this.originalData = obs;
        if (!this.page || this.page < 1) {
            this.page = 1;
        }
        this.pageSize = 20;
        this.drawPage();
        this.updateCounts(obs.length);
        this.tableTasks = false;

    }
    loadDataIntervention(data: any) {
        interface DataItem {
            [key: string]: string[];
        }

        this.dataIntervention = [];
        this.tableLoading = true;
        // this.data = result.data;
        this.totalRecords = (data[0]) ? data[0].ticketinterventionid.length : 0;

        // Create an array of objects to hold the values
        const resultObjects: { [key: string]: string }[] = Array.from({ length: this.totalRecords }, () => ({}));

        // Iterate over the data array and distribute values
        if (data.length > 0) {
            data.forEach((item: DataItem) => {
                const key: string = Object.keys(item)[0];
                item[key].forEach((value: string, index: number) => {
                    resultObjects[index][key] = value;
                });
            });
        }
        this.originalData = resultObjects;
        this.dataIntervention = resultObjects;
        if (!this.page || this.page < 1) {
            this.page = 1;
        }
        this.pageSize = 20;
        this.drawPage();
        this.updateCounts(data.length);
        this.tableLoading = false;
    }

    loadDataPedidos(obs: any[], metadata?: any) {
        this.data = [];
        this.tablePedidosLoading = true;

        if (this.serverSidePagination && metadata) {
            this.data = obs;
            this.page = metadata.page + 1;
            this.updateCountsPedidos(metadata.count);
        } else {
            this.originalData = obs;
            this.totalRecords = obs.length;

            if (!this.page || this.page < 1) {
                this.page = 1;
            }

            this.pageSize = 10;
            this.drawPage();

            this.updateCountsPedidos(obs.length);
        }

        this.tablePedidosLoading = false;
    }

    tableLoadingProducts: boolean = false;
    originalDataProducts: any[] = [];
    dataProducts: any[] = [];
    loadDataProducts(data: any) {
        interface DataItem {
            [key: string]: string[];
        }

        this.dataProducts = [];
        this.tableLoadingProducts = true;
        this.totalRecords = data.length;

        let fData = normalizedResp(data);
        fData = sortData(fData);

        this.originalDataProducts = fData;
        this.dataProducts = fData;

        this.page = 1;
        this.pageSize = 20;

        this.drawPage();
        this.updateCounts(fData.length);

        this.tableLoadingProducts = false;

        //** */
        function normalizedResp(resp: any) {
            if (!resp || resp === "" || resp.length === 0) {
                return [];
            }

            const keys = resp.map((obj: any) => Object.keys(obj)[0]);
            const numberOfRows = resp[0]?.[keys[0]].length ?? 0;

            let data: any = [];
            for (let i = 0; i < numberOfRows; i++) {
                const row: any = {};
                for (let j = 0; j < keys.length; j++) {
                    let key: any = keys[j];
                    row[key] = resp[j][key][i];
                }
                data.push(row);
            }
            return data;
        }
        function sortData(data: any) {
            return data.sort((a: any, b: any) => {
                let aName = a.productname;
                let bName = b.productname;
                return aName.localeCompare(bName);
            });
        }
    }
}